"use client";

import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { cn } from "@scott/ui/client";
import type * as React from "react";

const Accordion = AccordionPrimitive.Root;

const AccordionItem = ({
  className,
  ref,
  ...props
}: React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item> & {
  ref?: React.RefObject<React.ElementRef<
    typeof AccordionPrimitive.Item
  > | null>;
}) => (
  <AccordionPrimitive.Item className={cn("", className)} ref={ref} {...props} />
);
AccordionItem.displayName = "AccordionItem";

export interface AccordionTriggerProps
  extends AccordionPrimitive.AccordionTriggerProps,
    React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger> {
  iconrotationangle?: string;
  hasicon?: boolean;
}

const AccordionTrigger = ({
  className,
  children,
  ref,
  ...props
}: AccordionTriggerProps & {
  ref?: React.RefObject<React.ElementRef<
    typeof AccordionPrimitive.Trigger
  > | null>;
}) => (
  <AccordionPrimitive.Header className="flex">
    <AccordionPrimitive.Trigger
      className={cn(
        "flex flex-1 items-center justify-between font-medium transition-all",
        className
      )}
      ref={ref}
      {...props}
    >
      {children}
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
);
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const AccordionContent = ({
  className,
  children,
  ref,
  ...props
}: React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content> & {
  ref?: React.RefObject<React.ElementRef<
    typeof AccordionPrimitive.Content
  > | null>;
}) => (
  <AccordionPrimitive.Content
    className="overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
    ref={ref}
    {...props}
  >
    <div className={cn("pt-0 pb-4", className)}>{children}</div>
  </AccordionPrimitive.Content>
);

AccordionContent.displayName = AccordionPrimitive.Content.displayName;

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
